import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftraggeber, IRolle } from "../types/Types";

/**
 * @author mb
 */
export const StammdatenAPI = createApi({
    reducerPath: "stammdatenAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "stammdaten",
            credentials: 'include'
        }),
    tagTypes: ['stammdatenAPI'], // for caching
    endpoints: (builder) => ({
        getRollen: builder.mutation<IRolle[], void>(
            {
                query: () => ({
                    url: 'roles/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getAuftraggeber: builder.mutation<IAuftraggeber, string>(
            {
                query: (uid) => ({
                    url: 'auftraggeber/'+uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getAuftraggeberListe: builder.mutation<IAuftraggeber[], void>(
            {
                query: () => ({
                    url: 'auftraggeber/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        createOrUpdateAuftraggeber: builder.mutation<IAuftraggeber, IAuftraggeber>(
            {
                query: (dto) => ({
                    url: 'auftraggeber/',
                    method: 'put',
                    credentials: 'include',
                    body: dto,
                })
            }
        ),
        deleteAuftraggeber: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: 'auftraggeber/' + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),
        
    })
});

export const {
    
    useGetRollenMutation,
    useGetAuftraggeberListeMutation,
    useGetAuftraggeberMutation,
    useCreateOrUpdateAuftraggeberMutation,
    useDeleteAuftraggeberMutation

} = StammdatenAPI;
